import script from "./SuggestComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuggestComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SuggestComponent.vue?vue&type=style&index=0&id=5f142338&lang=css"

const __exports__ = script;

export default __exports__